import { render, staticRenderFns } from "./PageWithoutTree.vue?vue&type=template&id=78f697ff&scoped=true&"
import script from "./PageWithoutTree.vue?vue&type=script&lang=js&"
export * from "./PageWithoutTree.vue?vue&type=script&lang=js&"
import style0 from "./PageWithoutTree.vue?vue&type=style&index=0&id=78f697ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f697ff",
  null
  
)

export default component.exports